export default {
	"fcb-class-name": "en-fcb-box",
	"video-btn": "동영상 보기",
	"fcb-page1": {
		"text1": "OFFICIAL PARTNER OF FC BARCELONA",
		"text2": "EBC 파이낸셜 그룹은 FC 바르셀로나의 FX 파트너로 협력하게 되었습니다. 이 파트너십을 통해 EBC는 FX 업계에서 독특한 입지를 확립하게 되었습니다.",
		"text3": "",
	},
	"fcb-page2": {
		"text1": "열정으로 시작해, 신뢰로 완성하다.",
		"text2": "열정이 담긴 모든 만남은 혹독한 도전이기도 합니다.<br/>그 도전은 단순한 승패를 넘어서고, 결과조차 초월합니다.<br/>변화를 향한 여정에서, 우리는 결코 혼자가 아닙니다.<br/>EBC는 지식과 기술을 기반으로 업계의 변화를 주도하고자 출발선에 섰습니다.초심을 지키며 변함 없이 나아가겠습니다.",
	},
	"fcb-page3": {
		"text1": "클럽, 그 이상의 클럽",
		"text2": "축구를 잘 모르셔도, 이 이름만은 아실 겁니다.단순한 팀이 아닌, 하나의 전설이니까요.",
		"text3": `FC 바르셀로나는 120년이 넘는 전통을 자랑하며, 세계에서 가장 사랑받는 축구 클럽 중 하나입니다. 마라도나, 메시, 호나우지뉴, 과르디올라 같은 전설적인 스타 선수와 감독들의 활약을 지켜봐 왔습니다. 바르셀로나는 다른 클럽과는 차원이 다른 독특한 스타일을 가지고 있으며, "클럽 그 이상의 클럽"이라는 본질을 완벽히 보여주고 있습니다.`,
		"text4": "EBC는 트레이딩을 넘어서, 포괄적인 국제 금융 생태계 구축에 힘쓰고 있습니다.",
	},
	"fcb-page4": {
		"text1": "새로운 벤치마크 창조",
		"text2": "세계 최고 수준의 선수들이 모인 팀, 열정과 꿈을 키우는 체계적인 유소년 시스템, 빛나는 업적을 증명하는 수많은 트로피, 그리고 사회를 위한 지속적인 기여. 이 모든 것이 FC 바르셀로나를 축구계의 상징이자 기준으로 만들어왔습니다.",
		"text3": `EBC와 FC 바르셀로나의 파트너십은, 서로의 강점을 인정하고 존중하는 신뢰의 상징입니다.
EBC는 모든 트레이더에게 진심으로 다가간다는 신념을 지켜오고 있으며,
세계 최고 수준의 금융 규제, 종합적인 자산 보호 시스템, 그리고 국제적으로 인정받는 영향력을 바탕으로
업계의 새로운 기준으로 자리매김하고 있습니다.`,
	},
	"fcb-page5": {
		"text1": `기술 혁신으로 "드림팀" 결성`,
		"text2": `FC 바르셀로나는 볼 점유율, 짧은 패스, 팀워크를 중시하는 독자적인 플레이 스타일로 세계적인 명성을 얻고 있습니다. 이 전략은 단순한 피지컬보다 기술적 완성도와 전술적 지능이 승부를 가른다는 사실을 강조하며, 현대 축구의 전술 흐름에 큰 영향을 미쳤습니다.`,
		"text3": "EBC는 기술 혁신에 전념하며, 항상 국제 기준의 최전선에 서 있습니다. 투자자에게는 컴플라이언스, 전문성, 효율성, 안정성을 두루 갖춘 국제 금융 생태계를 제공하고 있습니다."
	},
	"fcb-page6": {
		"text1": "더 나은 내일을 향해, 최고를 향한 약속",
		"text2": "존중, 노력, 야망, 팀워크, 겸손함은 FC 바르셀로나의 핵심 가치입니다. 클럽은 이러한 가치를 바탕으로, 선수들이 최고의 역량을 발휘할 수 있도록 끊임없이 동기를 부여합니다. 이 같은 철학은 EBC의 신념과 깊이 맞닿아 있습니다.",
		"text3": "EBC는 성실과 존중의 원칙을 바탕으로, 모든 트레이더의 열정과 기대를 소중히 여깁니다. 업계의 투명성을 높이고 성장을 선도하며, 공정한 사회를 만드는 데 기여하는 것을 사명으로 삼고 있습니다.",
		"text4": "Together, Let's Build The Future.",
	},
	"fcb-page7": {
		"text1": "관련 동향",
	}
}